import { fetchData } from "../FetchApi";

class ReportService {
  async downloadReport(reportType, filename) {
    const response = await fetchData(`report/${reportType}/export`);

    if (!response) {
      throw new Error("Export failed");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    try {
      a.click();
    } finally {
      a.remove();
      window.URL.revokeObjectURL(url);
    }
  }

  async downloadCustomerReport() {
    return this.downloadReport("customer", "customer-report.xlsx");
  }
}

export default new ReportService();
